module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showComponent) ? _c('div', {
    class: _vm.$style.root
  }, [(!_vm.permissions.includes("refreshCreative")) ? _c('b-alert', {
    staticClass: "error",
    attrs: {
      "show": "show",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.you-have-reached-maximum-creative-limit', {
    max: _vm.creativeRefresh.max
  })))]) : [_c('gotu-nav-button', {
    staticClass: "mb-2",
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.$refs.modal.show()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.ask-for-creative-refresh')))]), _c('p', [_vm._v(_vm._s(_vm.$t('pos.campaign.creative-refresh-request', {
    current: _vm.creativeRefresh.current,
    max: _vm.creativeRefresh.max
  })))]), _c('b-modal', {
    ref: "modal",
    staticClass: "creative-refresh-modal",
    attrs: {
      "size": "sm",
      "hide-footer": true,
      "title": _vm.$t("pos.campaign.ask-for-creative-refresh"),
      "closeTitle": _vm.$t('pos.buttons.close')
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pos.campaign.confirm-creative-refresh')))]), _c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.loading,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.refreshCreative
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.confirm')))])], 1)]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d8634c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/creative-refresh/CreativeRefresh.vue
// module id = 2029
// module chunks = 1